module.exports = __webpack_public_path__ + "img/Psych_text05a_knowledge.2039fff7.png";